"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { Text as t } from "../../atoms/Text/Text.mjs";
import { Button as n } from "../../atoms/Button/Button.mjs";
import { Dialog as r, DialogClose as i, DialogContent as a, DialogDescription as o, DialogFooter as s, DialogHeader as c, DialogTitle as l } from "../../atoms/Dialog/Dialog.mjs";
import { jsx as u, jsxs as d } from "react/jsx-runtime";
import { Close as f } from "@videoblocks/react-icons";
//#region src/components/organisms/ConfirmationModal/ConfirmationModal.tsx
var p = ({ isOpen: p, title: m, content: h, onCancel: g, onConfirm: _, confirmLabel: v = "Confirm", cancelLabel: y = "Cancel", className: b }) => /* @__PURE__ */ u(r, {
	open: p,
	onOpenChange: (e) => !e && g(),
	children: /* @__PURE__ */ d(a, {
		className: e("gap-10 p-8 rounded-sm border-0 dark:bg-neutral-dark-1000", b),
		showCloseButton: !1,
		children: [
			/* @__PURE__ */ d(c, {
				className: "flex-row items-center justify-between text-gray-900",
				children: [/* @__PURE__ */ u(l, {
					fontSize: "2xl",
					children: m
				}), /* @__PURE__ */ u(i, {
					className: "opacity-70 hover:opacity-100 transition-opacity cursor-pointer",
					"aria-label": "close",
					children: /* @__PURE__ */ u(f, { className: "w-4 h-4 fill-current" })
				})]
			}),
			/* @__PURE__ */ u(o, {
				asChild: !0,
				children: /* @__PURE__ */ u(t, {
					fontSize: "base",
					fontWeight: "regular",
					className: "text-gray-900",
					children: h
				})
			}),
			/* @__PURE__ */ d(s, {
				className: "gap-4",
				children: [/* @__PURE__ */ u(i, {
					asChild: !0,
					children: /* @__PURE__ */ u(n, {
						variant: "outlined-dark",
						children: y
					})
				}), /* @__PURE__ */ u(n, {
					onClick: _,
					children: v
				})]
			})
		]
	})
});
//#endregion
export { p as ConfirmationModal };
